<app-owners
	[contacts]="contacts$ | async"
	[dealId]="dealId">
</app-owners>